import { render, staticRenderFns } from "./EADList.vue?vue&type=template&id=5ae9f9dc&scoped=true&"
import script from "./EADList.vue?vue&type=script&lang=ts&"
export * from "./EADList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae9f9dc",
  null
  
)

export default component.exports